// extracted by mini-css-extract-plugin
export var circle = "_8l-1";
export var exitConfirmationModal = "_8l-5";
export var iframe = "_8l-0";
export var offline = "_8l-3";
export var online = "_8l-2";
export var workstationSelectError = "_8l-4";